/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * exemONE target Api
 * OpenAPI spec version: 1.0.0
 */

export type TargetStatusRequestTargetKind =
  (typeof TargetStatusRequestTargetKind)[keyof typeof TargetStatusRequestTargetKind];

export const TargetStatusRequestTargetKind = {
  ALTIBASE_REPLICATION: 'ALTIBASE_REPLICATION',
  APPLICATION: 'APPLICATION',
  APPLICATION_GROUP: 'APPLICATION_GROUP',
  AWS: 'AWS',
  AWS_ACCOUNT: 'AWS_ACCOUNT',
  AWS_AURORA: 'AWS_AURORA',
  AWS_DMS_REPLINSTANCE: 'AWS_DMS_REPLINSTANCE',
  AWS_DMS_TASK: 'AWS_DMS_TASK',
  AWS_DOCUMENTDB: 'AWS_DOCUMENTDB',
  AWS_DYNAMODB: 'AWS_DYNAMODB',
  AWS_EC2: 'AWS_EC2',
  AWS_ECS_CLUSTER: 'AWS_ECS_CLUSTER',
  AWS_ECS_SERVICE: 'AWS_ECS_SERVICE',
  AWS_ELASTICACHE_CLUSTER: 'AWS_ELASTICACHE_CLUSTER',
  AWS_ELASTICACHE_NODE: 'AWS_ELASTICACHE_NODE',
  AWS_ELASTICACHE_SERVERLESS: 'AWS_ELASTICACHE_SERVERLESS',
  AWS_ELASTICACHE_SHARD: 'AWS_ELASTICACHE_SHARD',
  AWS_LAMBDA: 'AWS_LAMBDA',
  AWS_LIGHTSAIL_DATABASE: 'AWS_LIGHTSAIL_DATABASE',
  AWS_LIGHTSAIL_INSTANCE: 'AWS_LIGHTSAIL_INSTANCE',
  AWS_RDS: 'AWS_RDS',
  AWS_REDSHIFT: 'AWS_REDSHIFT',
  AWS_S3: 'AWS_S3',
  AWS_VPC: 'AWS_VPC',
  AZURE_ACCOUNT: 'AZURE_ACCOUNT',
  AZURE_BLOB_STORAGE: 'AZURE_BLOB_STORAGE',
  AZURE_CACHE_FOR_REDIS: 'AZURE_CACHE_FOR_REDIS',
  AZURE_CACHE_FOR_REDIS_ENTERPRISE: 'AZURE_CACHE_FOR_REDIS_ENTERPRISE',
  AZURE_COSMOS_DB: 'AZURE_COSMOS_DB',
  AZURE_DATABASE_FOR_MYSQL: 'AZURE_DATABASE_FOR_MYSQL',
  AZURE_DATABASE_FOR_POSTGRESQL: 'AZURE_DATABASE_FOR_POSTGRESQL',
  AZURE_FUNCTIONS: 'AZURE_FUNCTIONS',
  AZURE_SQL_DATABASE: 'AZURE_SQL_DATABASE',
  AZURE_VIRTUAL_MACHINES: 'AZURE_VIRTUAL_MACHINES',
  BUSINESS_SERVICE: 'BUSINESS_SERVICE',
  BUSINESS_SERVICE_GROUP: 'BUSINESS_SERVICE_GROUP',
  CLOUD_GROUP: 'CLOUD_GROUP',
  CLUSTER: 'CLUSTER',
  CLUSTER_ROLE: 'CLUSTER_ROLE',
  CLUSTER_ROLE_BINDING: 'CLUSTER_ROLE_BINDING',
  CONFIGMAP: 'CONFIGMAP',
  CONTAINER: 'CONTAINER',
  CRONJOB: 'CRONJOB',
  CUBRID: 'CUBRID',
  CUBRID_BROKER: 'CUBRID_BROKER',
  DAEMONSET: 'DAEMONSET',
  DATABASE: 'DATABASE',
  DATABASE_CLUSTER: 'DATABASE_CLUSTER',
  DATABASE_GROUP: 'DATABASE_GROUP',
  DEPLOYMENT: 'DEPLOYMENT',
  ELASTICSEARCH: 'ELASTICSEARCH',
  FILESYSTEM: 'FILESYSTEM',
  GPU: 'GPU',
  HOST: 'HOST',
  HOST_PORT: 'HOST_PORT',
  HPA: 'HPA',
  INFRA_GROUP: 'INFRA_GROUP',
  INGRESS: 'INGRESS',
  INGRESS_CONTROLLER_WORKLOAD: 'INGRESS_CONTROLLER_WORKLOAD',
  INGRESS_GATEWAY_WORKLOAD: 'INGRESS_GATEWAY_WORKLOAD',
  INTEGRATION_SERVER: 'INTEGRATION_SERVER',
  INTEGRATION_SERVER_GROUP: 'INTEGRATION_SERVER_GROUP',
  INTERFACE: 'INTERFACE',
  JOB: 'JOB',
  KAFKA_BROKER: 'KAFKA_BROKER',
  KAFKA_BROKER_TOPIC: 'KAFKA_BROKER_TOPIC',
  KAFKA_CLIENT: 'KAFKA_CLIENT',
  KAFKA_CLUSTER: 'KAFKA_CLUSTER',
  KAFKA_CLUSTER_CONSUMER: 'KAFKA_CLUSTER_CONSUMER',
  KAFKA_CLUSTER_CONSUMER_GROUP: 'KAFKA_CLUSTER_CONSUMER_GROUP',
  KAFKA_CLUSTER_PARTITION: 'KAFKA_CLUSTER_PARTITION',
  KAFKA_CLUSTER_TOPIC: 'KAFKA_CLUSTER_TOPIC',
  KAFKA_CLUSTER_TOPIC_CONSUMER_GROUP: 'KAFKA_CLUSTER_TOPIC_CONSUMER_GROUP',
  KAFKA_ZOOKEEPER: 'KAFKA_ZOOKEEPER',
  LOG: 'LOG',
  MESSAGE_QUEUE_GROUP: 'MESSAGE_QUEUE_GROUP',
  MIG: 'MIG',
  NAMESPACE: 'NAMESPACE',
  NETWORK_DEVICE: 'NETWORK_DEVICE',
  NETWORK_DEVICE_GROUP: 'NETWORK_DEVICE_GROUP',
  NETWORK_OBJECT: 'NETWORK_OBJECT',
  NETWORK_OBJECT_GROUP: 'NETWORK_OBJECT_GROUP',
  NODE: 'NODE',
  PERSISTENT_VOLUME: 'PERSISTENT_VOLUME',
  PERSISTENT_VOLUME_CLAIM: 'PERSISTENT_VOLUME_CLAIM',
  POD: 'POD',
  POSTGRESQL_REPLICATION: 'POSTGRESQL_REPLICATION',
  POSTGRESQL_REPLICATION_CLUSTER: 'POSTGRESQL_REPLICATION_CLUSTER',
  PROCESS: 'PROCESS',
  PROMETHEUS: 'PROMETHEUS',
  REPLICASET: 'REPLICASET',
  ROLE: 'ROLE',
  ROLE_BINDING: 'ROLE_BINDING',
  ROUTE: 'ROUTE',
  RUM: 'RUM',
  RUM_GROUP: 'RUM_GROUP',
  SERVICE: 'SERVICE',
  SERVICE_ACCOUNT: 'SERVICE_ACCOUNT',
  STATEFULSET: 'STATEFULSET',
  STORAGE_CLASS: 'STORAGE_CLASS',
  URL: 'URL',
  URL_GROUP: 'URL_GROUP',
  VIRTUAL_SERVICE: 'VIRTUAL_SERVICE',
  WEBSERVER: 'WEBSERVER',
  WEBSERVER_GROUP: 'WEBSERVER_GROUP',
} as const;
